import { ChangeDetectorRef, Component, HostListener, Inject, OnDestroy, OnInit, PLATFORM_ID, ViewChild } from '@angular/core';
import { AuthConfig, AuthService, FCMNotificationActionEnum, FCMNotificationActionGroupEnum, proBySourceEnum, ResponseObject } from './Services/auth.service';
import { StripeService } from './Services/stripe.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { SelectItem } from 'primeng/api';
import { ArtistsService } from './Services/artists.service';
import { GalleriesService, GalleryItems } from './Services/galleries.service';
import { NotificationsService } from './Services/shared/notifications.service';
import { NotificationTypes } from './app.enums';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import { AppSettings } from './app.settings';
import { StripePlans } from './models/stripe.model';
import { OnBoardingService } from './Services/shared/onboarding.service';
import { ShareService } from './Services/shared/share.service';
import { UsersService } from './Services/users.service';
import { DatePipe, isPlatformBrowser } from '@angular/common';
import { MessagingService } from './Services/messaging.service';
import { OverlayPanel } from 'primeng/overlaypanel';
import { Subject, takeUntil } from 'rxjs';
import { TranslocoService } from '@jsverse/transloco';
import { environment } from '../environments/environment';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css'],
    providers: [DatePipe],
    standalone: false
})
export class AppComponent implements OnInit, OnDestroy {
  @ViewChild('sidebarOverlay') sidebarOverlay!: OverlayPanel;

  // Build stamp baked at build time by tools/set-env.js — shown in the version badge on every page.
  public readonly buildInfo = environment.build;
  // Build number zero-padded to 3 digits for display (e.g. 9 -> "009", 10 -> "010").
  public readonly buildNumberLabel = String(environment.build.number).padStart(3, '0');

  /** Phase-1 nav rework: regular artists get the new ds-shell (rail + bottom bar);
   *  everyone else (gallery/admin/judge/curator/event-only/impersonated) keeps the existing shell. */
  // NOTE: admin-impersonation (viewingRoleAsAdmin) DOES get the new shell so the impersonated
  // experience matches what the user sees; ds-shell shows a "Back to Admin" button in that case.
  public get useNewArtistShell(): boolean {
    return this.isArtist && !this.isEventOnlyArtist
      && !this.isJudge && !this.isCurator && !this.isOnProfilePage;
  }

  /** Phase-2 nav rework: gallery owners get the new ds-shell. GalleryStaff (judge/curator)
   *  keep the existing shell until the round-2 reduced rail. */
  public get useNewGalleryShell(): boolean {
    return this.isGallery && !this.isJudge && !this.isCurator
      && !this.isOnProfilePage;
  }

  /** True when ANY role should render the new single-nav shell. */
  public get useNewShell(): boolean {
    return this.useNewArtistShell || this.useNewGalleryShell;
  }

  // App initialization state - prevents flickering on page load
  public isAppReady: boolean = false;
  private destroy$ = new Subject<void>();

  public isAuthenticated!: boolean;
  public FreeTrialFeatureDialogVisible!: boolean;
  public isAdministrator!: boolean;
  public isSuperAdmin!: boolean;
  public isStripeDisplayPlansDialogVisible!: boolean;
  public isStripeCheckoutSuccessDialogVisible!: boolean;
  public isTourGuideDailogVisible!: boolean;
  public DailogVisible!: boolean;
  public stripeCheckoutSuccess!: string | null;
  public firstName!: string;
  public UserEmail!: string;
  public BusinessName!: string;
  public userLogoUrl!: string;
  public authConfig: AuthConfig = {} as AuthConfig;
  public isDropdownOpen: boolean = false;
  public dontShowAgain!: boolean;
  public isArtist: boolean = false;
  public isGallery: boolean = false;
  public isFreePlanUser: boolean = true;
  public memberSince: Date | undefined;
  public selectedRole: string | undefined;
  public selectedEntity: any;
  private timerIntervalId: number | undefined;
  public isUserSubscribedByStripe: boolean | undefined;
  message: any;
  // Switch-account role options. Two constraints pull against each other here:
  //
  // 1. The array reference MUST stay STABLE across change-detection cycles. A fresh array
  //    every call made the switch-account p-dropdown (with appendTo="body") re-process its
  //    options each CD while the panel was open, causing an infinite render loop that froze
  //    the page (bug #558, build 054).
  // 2. The labels MUST NOT be built before the language file has loaded. translate() is
  //    synchronous and returns the raw KEY when the active translation hasn't arrived yet,
  //    and the loader fetches assets/i18n/{lang}.json over HTTP. Memoising on first read
  //    (build 055) satisfied (1) but froze those raw keys forever, because the cache was
  //    keyed on the active lang and the lang never changes — so the dropdown showed
  //    "app.roleAsArtist" / "app.roleAsGallery" permanently.
  //
  // Both hold if the array is rebuilt ONLY when a translation actually loads or the
  // language changes (see the selectTranslation() subscription in ngOnInit) — never per CD.
  private _roles: SelectItem[] = [];
  public get roles(): SelectItem[] {
    return this._roles;
  }

  /** Rebuilds the switch-account role options in the currently loaded language. */
  private buildRoles(): void {
    this._roles = [
      { label: this.transloco.translate('app.roleAsArtist'), value: 'Artist' },
      { label: this.transloco.translate('app.roleAsGallery'), value: 'Gallery' },
    ];
  }
  public artistsLoading = true;
  public dropDownData: SelectItem[] = [];
  public loggedinRole: string | undefined;
  public viewingRoleAsAdmin: boolean = false;
  public PersonalImgUrl!: string;
  // public stripePlans: StripePlans[] = [];
  public showDashboard: boolean = true;
  public showSidebar: boolean = true;
  public isOnFreeTrial!: boolean;
  public hasFreeTrailEnded: boolean | undefined;
  public remainingTime: any = {};
  public proBySourceEnum: any = proBySourceEnum;
  public proBySource!: string
  public notifications: any[] = [];
  public showNotifications: boolean = false;
  public isLoadingMessages: boolean = false;
  public isLoadingNotifications: boolean = false;
  public chatmessages: any[] = [];
  public countUnreadNotificaion!: number;
  public countUnreadchatbox!: number;
  public showMessages: boolean = false;
  public isChatBoxMessagesShow: boolean = false;
  public isSmallScreen = false; // Initialize with default value
  public isSidebarVisible: boolean = false;
  public sidebarVisible: boolean = false;
  public isEventOnlyArtist: boolean = false; // Check if user is event-only artist
  public isJudge: boolean = false;
  public isCurator: boolean = false;
  public isOnProfilePage: boolean = false;
  public isOnAuthPage: boolean = false;
  public isOnReviewPage: boolean = false;
  public isOnJudgeCuratorRoute: boolean = false;

  constructor(@Inject(PLATFORM_ID) private platformId: Object,
    private spinnerService: NgxSpinnerService,
    private authService: AuthService,
    private stripeService: StripeService,
    private artistService: ArtistsService,
    private ngxSpinnerService: NgxSpinnerService,
    private notificationsService: NotificationsService,
    private galleriesService: GalleriesService,
    private router: Router,
    private onBoardingService: OnBoardingService,
    private shareService: ShareService,
    private userService: UsersService,
    private messagingService: MessagingService,
      private cdr: ChangeDetectorRef,
    private transloco: TranslocoService

  ) {
    if (isPlatformBrowser(this.platformId)) {
      this.isSmallScreen = window.innerWidth <= 900;
    }
  }

   public toggleSidebar() {
    this.sidebarVisible = true;
  }

 
  @HostListener('window:resize')
  onResize() {
    if (isPlatformBrowser(this.platformId)) {
      this.checkScreenSize();
    }
  }

  private checkScreenSize() {
    if (isPlatformBrowser(this.platformId)) {
      this.isSmallScreen = window.innerWidth <= 900;
      this.cdr.detectChanges();
    }
  }

  public ngOnInit(): void {
    // Rebuild the role labels whenever the active translation is (re)loaded — on first
    // load and on every language switch. Building them eagerly yields the raw keys,
    // because the translation file is fetched asynchronously (see the `roles` getter).
    this.transloco.selectTranslation()
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => this.buildRoles());

    if (isPlatformBrowser(this.platformId)) {
      this.isSmallScreen = window.innerWidth <= 900;

      // Track route changes to detect profile page and auth pages
      this.router.events.pipe(
        filter(event => event instanceof NavigationEnd),
        takeUntil(this.destroy$)
      ).subscribe((event: any) => {
        this.isOnProfilePage = event.url.includes('/profile/') || event.url.includes('/artist-onboarding-checklist');
        this.isOnAuthPage = event.url === '/login' || event.url === '/signup' || event.url.startsWith('/signup/') || event.url === '/registration' || event.url.startsWith('/password-forget/');
        this.isOnReviewPage = event.url.includes('/review');
        this.isOnJudgeCuratorRoute = event.url.startsWith('/judge') || event.url.startsWith('/curator');
      });
      // Check initial route
      this.isOnProfilePage = this.router.url.includes('/profile/') || this.router.url.includes('/artist-onboarding-checklist');
      this.isOnAuthPage = this.router.url === '/login' || this.router.url === '/signup' || this.router.url.startsWith('/signup/') || this.router.url === '/registration' || this.router.url.startsWith('/password-forget/');
      this.isOnReviewPage = this.router.url.includes('/review');
      this.isOnJudgeCuratorRoute = this.router.url.startsWith('/judge') || this.router.url.startsWith('/curator');

      // CRITICAL: Set isAuthenticated synchronously BEFORE first render
      // This prevents login page flash on production (FOUC issue)
      this.isAuthenticated = this.authService.isAuthenticated();
      this.authConfig = this.authService.getAuthConfig();

      // Initialize remaining auth state after DOM is ready
      // Use setTimeout(0) to avoid ExpressionChangedAfterItHasBeenCheckedError
      setTimeout(() => {
        try {
          this.initializeAuthenticatedState();
        } catch (err) {
          console.error('Error initializing authenticated state:', err);
        }
        this.isAppReady = true;
        this.cdr.detectChanges();
      }, 0);
    } else {
      // Server-side: Mark as ready immediately but don't check auth
      this.isAppReady = true;
    }
  }

  public ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
    if (this.timerIntervalId != null) {
      window.clearInterval(this.timerIntervalId);
    }
  }

  /**
   * Initialize all authenticated state - called after APP_INITIALIZER completes
   */
  private initializeAuthenticatedState(): void {
    this.authConfig = this.authService.getAuthConfig();
    this.isAuthenticated = this.authService.isAuthenticated();

    this.shareService.visibility$.pipe(takeUntil(this.destroy$)).subscribe(visibility => {
      this.showSidebar = visibility.sidebar;
    });

    this.isAdministrator = this.authService.isAdministrator();
    this.isSuperAdmin = this.authService.IsSuperAdmin();

    if (this.isAuthenticated) {
      this.viewingRoleAsAdmin = this.authService.isViewingAsAdministrator();

      this.isArtist = this.authConfig.IsArtist || false;
      this.isGallery = this.authConfig.IsGallery || false;

      // Apply consistent background to body for all roles
      document.body.classList.add('artist-layout');
      this.isFreePlanUser = this.authService.isFreePlanUser();
      this.isChatBoxMessagesShow = this.authService.IsChatboxMessages();

      // Check if user is event-only artist (restricted access)
      this.isEventOnlyArtist = this.authService.isEventArtist();
      this.isJudge = this.authService.isJudge();
      this.isCurator = this.authService.isCurator();
      if (this.isArtist || this.isGallery) {
        this.messagingService.getUnreadNotificationCount().pipe(takeUntil(this.destroy$)).subscribe(count => {
          this.countUnreadNotificaion = count;
        });

        this.messagingService.getUnreadChatboxCount().pipe(takeUntil(this.destroy$)).subscribe(count => {
          this.countUnreadchatbox = count;
        });
        this.messagingService.requestPermission();

        this.reciveMessages();
      }
      this.proBySource = this.authService.proBySource();
      this.isOnFreeTrial = this.authService.isOnFreetrial();
      this.hasFreeTrailEnded = this.authService.hasFreeTrialEnded();
      var currentUser = this.authService.getCurrentUser();
      this.onBoardingService.getUpdatedLocalStorageValue.pipe(takeUntil(this.destroy$)).subscribe((tourVisible: boolean) => {
        this.showDashboard = !tourVisible;
      });
      if (currentUser) {
        this.firstName = currentUser.FirstName;
        this.UserEmail = currentUser.EmailAddress;
        this.userLogoUrl = currentUser.LogoUrl;
        this.memberSince = currentUser.DateJoined;
        this.PersonalImgUrl = currentUser.PersonalImgUrl;
        this.BusinessName = currentUser.BusinessName;
      }

      this.stripeCheckoutSuccess = localStorage.getItem(AppSettings.ON_STRIPE_CHECKOUT_SUCCESS);
      if (this.stripeCheckoutSuccess) {
        this.isStripeCheckoutSuccessDialogVisible = JSON.parse(this.stripeCheckoutSuccess);
        localStorage.removeItem(AppSettings.ON_STRIPE_CHECKOUT_SUCCESS);
      }

      this.checkFreeTrialStatus();

      //check if we need to show the "Congratulations! Your free trial is started" dialog
      var featureDialogVisible = localStorage.getItem('FreeTrialFeatureDialogVisible') === 'true';
      if (featureDialogVisible == true) {
        localStorage.removeItem('FreeTrialFeatureDialogVisible');
        this.FreeTrialFeatureDialogVisible = true;
      }
    }

    const isNewUser = localStorage.getItem('isNewUser') === 'true';
    if (isNewUser) {
      localStorage.removeItem('isNewUser');

      if (this.isArtist) {
        this.router.navigate(['/artist-onboarding-checklist']);
      } else if (this.isGallery) {
        this.router.navigate(['/']);
      }
    }
  }
  public reciveMessages() {
    this.messagingService.currentMessage.subscribe((data: any) => {
      this.CountUnreadchatbox();
      this.CountUnreadNotificaion();
      // this.messagingService.receiveMessage();
    });
  }
  private checkFreeTrialStatus() {
    var isOnFreeTrial: boolean = this.authService.isOnFreetrial();
    if (!isOnFreeTrial) {
      //if the user is not on the free trial, we don't need to calculate the remaining time
      return;
    }
    //the user is on the free trial so find out the expiry date of this trial
    var initialTrialExpiryDate = this.authService.getTrailExpiryDate();
    if (initialTrialExpiryDate == null) return;
    this.timerIntervalId = window.setInterval(() => {
      //calculate the remaining time in the free trial
      this.calculateRemainingTrialTime(initialTrialExpiryDate!);
    }, 1000);
  }
  private calculateRemainingTrialTime(initialTrialExpiryDate: Date) {
    const currentDate = new Date();
    const expiryDate = new Date(initialTrialExpiryDate);

    const diff = expiryDate?.getTime() - currentDate.getTime();
    if (diff <= 0) {
      this.remainingTime = null;
      this.isOnFreeTrial = false;
      if (this.timerIntervalId != null) {
        //cancel the timer
        window.clearInterval(this.timerIntervalId);
      }

      //the free trial of this user has ended so make an api call
      this.spinnerService.show();
      this.userService.endFreeTrail().subscribe((responce: ResponseObject) => {
        if (responce.Success) {
          this.authService.setAccessToken(responce.ResponseData);
          window.location.reload();
        }
        this.spinnerService.hide();
      }, error => { console.error(error); this.spinnerService.hide(); });

      this.remainingTime = { days: 0, hours: 0, minutes: 0, seconds: 0 };
      return;
    }

    const days = Math.floor(diff / (1000 * 60 * 60 * 24));
    const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((diff % (1000 * 60)) / 1000);
    this.remainingTime = {};

    if (days > 0) {
      // Display only the days when days are greater than 0
      this.remainingTime = { display: this.transloco.translate('app.trialDaysRemaining', { days: days }) };
    } else {
      // Display hours, minutes, and seconds when days are 0
      if (hours >= 1) {
        //if hours are more than 1, cancel the timer for now
        if (this.timerIntervalId != null) {
          //cancel the timer
          window.clearInterval(this.timerIntervalId);
        }

        this.remainingTime = {
          display: this.transloco.translate('app.trialHoursRemaining', { hours: hours })
        };
      } else {
        this.remainingTime = {
          display: this.transloco.translate('app.trialMinutesSecondsRemaining', { minutes: minutes, seconds: seconds })
        };
      }
    }

    if (days >= 1) {
      //if days are more than 1, don't run the timer which consumes the resources
      if (this.timerIntervalId != null) {
        //cancel the timer
        window.clearInterval(this.timerIntervalId);
      }
    }
  }
  // Handles the closing of the Stripe payment dialog
  public onCloseStripePaymentDailog($event: boolean) {
    this.isStripeDisplayPlansDialogVisible = $event;
  }
  // Handles the selection of a role
  public onselectRole($event: any) {
    this.selectedRole = $event.value;
    if (this.selectedRole === 'Artist') {
      this.isDropdownOpen = true;
      this.getAllArtists();
    } else if (this.selectedRole === 'Gallery') {
      this.isDropdownOpen = true;
      this.fetchAllGalleries();
    }
  }
  // Returns the placeholder text for the dropdown
  public getPlaceholderText() {
    return this.selectedRole === 'Artist' ? this.transloco.translate('app.selectArtistPlaceholder') : this.transloco.translate('app.selectGalleryPlaceholder');
  }
  // Handles the selection of an ID
  public onselectedId($event: any) {
    if ($event && $event.value) {
      this.switchAccount($event.value);
      this.DailogVisible = false;
    } else {
      this.isDropdownOpen = false;
    }
  }
  // Toggles the dropdown visibility
  toggleDropdown() {
    this.isDropdownOpen = !this.isDropdownOpen;
  }
  public goBackToEvents(): void {
    if (this.isJudge) {
      this.router.navigate(['/judge/events']);
    } else if (this.isCurator) {
      this.router.navigate(['/curator/events']);
    }
  }

  // Logs out the user
  public logout($event: any) {
    this.authService.logout().subscribe((res) => {
      window.location.reload();
    });
  }
  // Shows the upgrade dialog
  public ShowUpgradeDailog() {
    this.isStripeDisplayPlansDialogVisible = true;
    // this.getAllPlans();
  }
  // Upgrades the user's account
  public upgradeAccount(stripePro: StripePlans) {
    this.spinnerService.show();
    this.stripeService.upgradeAccountPro(stripePro.PlanId, stripePro.Currency).subscribe(
      (response: ResponseObject) => {
        if (response.Success) {
          window.location.href = response.ResponseData;
        }
        this.spinnerService.hide();
      },
      error => { console.error(error); this.spinnerService.hide(); }
    );
  }
  // Fetches all artists
  private getAllArtists() {
    this.ngxSpinnerService.show();
    this.artistService.getArtistsDropdownData().subscribe(
      (artists: SelectItem[]) => {
        this.dropDownData = artists;
        this.artistsLoading = false;
        this.ngxSpinnerService.hide();
      },
      (error) => { this.handleRequestError(error); }
    );
  }
  // Fetches all galleries
  private fetchAllGalleries() {
    this.ngxSpinnerService.show();
    this.galleriesService.fetchDropdownData().subscribe(
      (galleries: SelectItem[]) => {
        this.dropDownData = galleries;
        console.log('Galleries: ', this.dropDownData);
        this.ngxSpinnerService.hide();
      },
      (error) => {
        console.error(error);
        this.ngxSpinnerService.hide();
      }
    );
  }
  // Fetches all plans
  // public getAllPlans() {
  //   if (this.isArtist || this.isGallery) {
  //     if (this.isFreePlanUser || this.isOnFreeTrial) {
  //       this.ngxSpinnerService.show();
  //       this.stripeService.getAllPlans().subscribe(
  //         (ApiResponce: StripePlans[]) => {
  //           console.log(ApiResponce);
  //           // this.stripePlans = ApiResponce;
  //           this.ngxSpinnerService.hide();
  //         },
  //         (error) => { console.error(error); this.ngxSpinnerService.hide(); }
  //       );
  //     }
  //   }
  // }

  // Handles request errors
  private handleRequestError(error: any) {
    this.artistsLoading = false;
    console.error(error);
    this.ngxSpinnerService.hide();
  }
  // Switches the account
  private switchAccount(data: SelectItem): void {
    this.ngxSpinnerService.show();
    this.authService.switchAccount(data.value).subscribe(
      (response) => {
        this.ngxSpinnerService.hide();
        if (response.Success) {
          this.messagingService.requestPermission();
          // Determine redirect based on role - artists go to ds-dashboard, galleries to ds-gallery-dashboard
          const redirectPath = this.selectedRole === 'Artist' ? '/ds-dashboard' : '/ds-gallery-dashboard';
          this.router.navigate([redirectPath]).then(() => {
            location.reload();
          });
          return;
        }
        this.notificationsService.showNotification(this.transloco.translate('app.errorTitle'), response.ResponseMessage, NotificationTypes.Error);
      },
      (error) => {
        console.error(error);
        this.ngxSpinnerService.hide();
      }
    );

  }
  // Exits the role view
  public exitRoleView($event: any) {
    this.ngxSpinnerService.show();
    this.authService.exitAccount().subscribe(
      (response: ResponseObject) => {
        this.ngxSpinnerService.hide();
        if (response.Success) {
          this.router.navigate(['/ds-admin-dashboard']).then(() => {
            location.reload();
          });
          return;
        }
        this.notificationsService.showNotification(this.transloco.translate('app.errorTitle'), response.ResponseMessage, NotificationTypes.Error);
      },
      (error) => {
        console.error(error);
        this.ngxSpinnerService.hide();
      }
    );
  }
  // Closes the Stripe payment plan dialog
  public onCloseStripePaymentPlanDialog() {
    this.isStripeDisplayPlansDialogVisible = false;
  }
  // Closes the Stripe checkout complete dialog
  public onCloseStripeCheckoutCompleteDailog() {
    this.isStripeCheckoutSuccessDialogVisible = false;
  }
  public onStartFreeTrail() {
    if (this.isArtist || this.isGallery) {
      this.ngxSpinnerService.show();
      this.userService.startFreeTrail().subscribe((responce) => {
        if (responce.Success) {
          this.ngxSpinnerService.hide();
          if (responce.ResponseData !== null) {
            console.log(responce.ResponseData)
            this.authService.setAccessToken(responce.ResponseData);
            this.isOnFreeTrial = true;
            localStorage.setItem('FreeTrialFeatureDialogVisible', 'true');
            window.location.reload();
          } else {
            console.error('Failed to start free trial. Response:', responce);
          }
        }
        this.ngxSpinnerService.hide();
        console.error('Error starting free trial:', Error);
      })
    }
  }
  public handleDialogClose(event: any) {
    this.FreeTrialFeatureDialogVisible = false;
  }
  public upgradeToProAccount() {
    this.isStripeDisplayPlansDialogVisible = true;
  }
  public fetchNotifications(topN: number): void {
    this.isLoadingNotifications = true;
    this.messagingService.fetchNotifications(topN).subscribe(
      (data) => {
        this.notifications = data.sort((a: { IsRead: any; }, b: { IsRead: any; }) => Number(a.IsRead) - Number(b.IsRead));
        this.isLoadingNotifications = false;
      },
      (error) => {
        console.error('Error fetching notifications:', error);
        this.isLoadingNotifications = false;
      }
    );
  }
  public fetchchatboxnotification(topN: number): void {
    this.isLoadingMessages = true;
    this.messagingService.fetchchatboxnotification(topN).subscribe(
      (data) => {
        this.chatmessages = data;
        this.isLoadingMessages = false;
      },
      (error) => {
        console.error('Error fetching chat messages:', error);
        this.isLoadingMessages = false;
      }
    );
  }
  public CountUnreadNotificaion(): void {
    this.messagingService.CountUnreadNotificaion().subscribe(
      (data) => {
        // Update the notifications array with the fetched data
        this.countUnreadNotificaion = data;
        this.messagingService.receiveMessage();
      },
      (error) => {
        console.error('Error fetching notifications:', error);
      }
    );
  }
  public CountUnreadchatbox(): void {
    this.messagingService.CountUnreadchatbox().subscribe(
      (data) => {
        // Update the notifications array with the fetched data
        this.countUnreadchatbox = data;
      },
      (error) => {
        console.error('Error fetching notifications:', error);
      }
    );
  }
  public toggleMessages(event: Event): void {
    event.stopPropagation();
    this.showMessages = !this.showMessages;
    this.showNotifications = false;
    if (this.showMessages) this.fetchchatboxnotification(10);
  }
  public toggleNotifications(event: Event): void {
    event.stopPropagation();
    this.showNotifications = !this.showNotifications;
    this.showMessages = false;
    if (this.showNotifications) this.fetchNotifications(10);
  }
  @HostListener('document:click', ['$event'])
  closeOnOutsideClick(event: Event) {
    const target = event.target as HTMLElement;
    if (!target.closest('.notification-container')) {
      this.showMessages = false;
      this.showNotifications = false;
    }
  }
  public navigateToNotificationsList() {
    this.router.navigate(['/notifications-list']);
    this.showNotifications = false;
    this.notifications = [];
  }
  public navigateToMessagesList() {
    this.router.navigate(['/inbox']);
    this.showMessages = false;
    this.chatmessages = [];
  }
  markasreadNotificaion(notification: any): void {
    this.messagingService.markasreadNotificaion(notification.EntityId).subscribe(
      (data) => {
        console.log(data)
        this.CountUnreadNotificaion()
        this.showNotifications = false
      },
      (error) => {
        console.error('Error fetching notifications:', error);
      }
    );
  }
 public handleNotificationClick(notification: any) {
    this.markasreadNotificaion(notification)
    if (this.authConfig.IsArtist) {
      if (notification.ActionTypeGroupName === FCMNotificationActionGroupEnum.Connection) {
        this.router.navigate([`/artists/connected-galleries`]);
      }

      if (notification.ActionTypeGroupName === FCMNotificationActionGroupEnum.Proposal) {
        this.router.navigate([`/view-proposals`]);
      }
      if (notification.ActionTypeGroupName === FCMNotificationActionGroupEnum.Consignment) {
        this.router.navigate([`/view-consignments`]);
      }
      if (notification.ActionTypeGroupName === FCMNotificationActionGroupEnum.Product) {
        this.router.navigate([`/artists/artworks`]);
      }

    }
    if (this.authConfig.IsGallery) {
      if (notification.ActionTypeGroupName === FCMNotificationActionGroupEnum.Connection) {
        this.router.navigate([`/connected-artists`]);
      }

      if (notification.ActionTypeGroupName === FCMNotificationActionGroupEnum.Proposal) {
        this.router.navigate([`/view-proposals`]);
      }

      if (notification.ActionTypeGroupName === FCMNotificationActionGroupEnum.Consignment) {
        this.router.navigate([`/view-consignments`]);
      }
      if (notification.ActionTypeGroupName === FCMNotificationActionGroupEnum.Product) {
        this.router.navigate([`/galleries/gallery-products`]);
      }

    }
  }
  public Chatwithuser(message: any) {
    this.markasreadchatboxNotificaion(message);
    if (message && message.SenderUserId) {
      this.router.navigate(['/inbox', message.SenderUserId,]);
    } else {
      console.error('Invalid data object:', message);
    }
  }
  markasreadchatboxNotificaion(message: any): void {
    this.messagingService.markasreadchatboxNotificaion(message.SenderUserId).subscribe(
      (data) => {
        console.log(data)
        this.CountUnreadchatbox();
        this.showMessages = false
      },
      (error) => {
        console.error('Error fetching notifications:', error);
      }
    );
  }

}